import { frontendURL } from '../../../helper/URLHelper';
import ConhecimentoView from './pages/ConhecimentoView.vue';
const meta = { permissions: ['administrator', 'agent'] };
export const routes = [
  { path: frontendURL('accounts/:accountId/conhecimento'), name: 'knowledge_index', component: ConhecimentoView, meta },
];
